import { BrandLogoViewModel, ImageViewObject, VideoViewObject } from '@/types/apiServerContract';
import { AbstractModalService } from '@/core/modals/AbstractModalService';

class ProductDetailsMediaOverlayService extends AbstractModalService {
    public show(
        images: ImageViewObject[],
        videos: VideoViewObject[],
        brandLogos: BrandLogoViewModel | undefined,
        brandName: string | undefined,
        brandUrl: string | undefined,
        aspectRatio: number,
        productName: string,
        thumbs: any, // Swiper
        activeIndex: number,
        brandUrlTarget: string | undefined) {
        return this.showModal({
            component: () => import(
                /* webpackPrefetch: true */
                '@/project/product/product-details/ProductDetailsMediaOverlay.vue'),
            componentAttrs: {
                images,
                videos,
                brandLogos,
                brandName,
                brandUrl,
                aspectRatio,
                productName,
                thumbs,
                activeIndex,
                brandUrlTarget
            },
            options: {
                contentAutoScroll: false,
                contentMaxHeight: false,
                disableBodyScroll: true,
                placement: 'center',
                showCloseButton: true,
                usePanelWrapper: false,
                wide: true
            }
        });
    }
}

export default new ProductDetailsMediaOverlayService();
